/* Cinch theme: homepage behavior (bundles, FAQ, smooth scroll, countdown, animation pausing) */
(function () {
  'use strict';

  var T = window.cinchTheme || {};
  var S = T.strings || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var abort = false;
  var io = null;

  function q(r, s) { return r.querySelector(s); }
  function qa(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function z(n) { return String(n).padStart(2, '0'); }

  ['wheel', 'touchstart'].forEach(function (ev) {
    window.addEventListener(ev, function () { abort = true; }, { passive: true });
  });

  /* ---------- smooth scroll to on-page anchors ---------- */
  function headerOffset() {
    var h = document.querySelector('.site-header:not(.is-static)');
    return (h ? h.offsetHeight : 0) + 8;
  }

  function pulse(t) {
    if (t.id !== 'bundles') return;
    var cards = qa(t, '.pkg-card');
    cards.forEach(function (x) { x.classList.add('pulse'); });
    setTimeout(function () { cards.forEach(function (x) { x.classList.remove('pulse'); }); }, 1500);
  }

  function smoothTo(sel) {
    var t;
    try { t = document.querySelector(sel); } catch (err) { return false; }
    if (!t) return false;
    var top = Math.max(0, t.getBoundingClientRect().top + window.scrollY - headerOffset());
    if (reduce) { window.scrollTo(0, top); return true; }
    var start = window.scrollY, dist = top - start;
    var dur = Math.min(1200, Math.max(650, Math.abs(dist) * 0.45)), t0 = null;
    abort = false;
    function step(ts) {
      if (abort) return;
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      window.scrollTo(0, start + dist * e);
      if (p < 1) requestAnimationFrame(step); else pulse(t);
    }
    requestAnimationFrame(step);
    return true;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (a) {
      var h = a.getAttribute('href');
      if (h && h.length > 1 && smoothTo(h)) e.preventDefault();
      return;
    }

    var faqBtn = e.target.closest && e.target.closest('.faq-q');
    if (faqBtn) {
      var list = faqBtn.closest('.faq');
      var item = faqBtn.closest('.faq-item');
      var open = !item.classList.contains('open');
      qa(list, '.faq-item.open').forEach(function (o) {
        o.classList.remove('open');
        q(o, '.faq-q').setAttribute('aria-expanded', 'false');
      });
      if (open) { item.classList.add('open'); faqBtn.setAttribute('aria-expanded', 'true'); }
    }
  });

  /* ---------- bundle and color picker (connected to real Shopify variants) ---------- */
  function initBundles(root) {
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    var variants = [];
    try { variants = JSON.parse(q(root, '[data-variants]').textContent); } catch (e) {}
    var hexMap = {};
    try { hexMap = JSON.parse(q(root, '[data-color-hex]').textContent); } catch (e) {}
    var state = {
      bundle: root.getAttribute('data-default-bundle') || '',
      color: root.getAttribute('data-default-color') || ''
    };
    var btn = q(root, '[data-add]');
    var lab = q(root, '[data-label]');
    var priceEl = q(root, '[data-price]');

    var modal = q(root, '[data-bundle-modal]');
    var modalImgs = modal ? qa(modal, '[data-media-img]') : [];
    var modalPlaceholder = modal ? q(modal, '[data-media-placeholder]') : null;
    var modalTitle = modal ? q(modal, '[data-modal-title]') : null;
    var modalPrice = modal ? q(modal, '[data-modal-price]') : null;
    var modalAdd = modal ? q(modal, '[data-modal-add]') : null;
    var lastFocus = null;

    function find(b, c) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if ((!b || v.b === b) && (!c || v.c === c)) return v;
      }
      return null;
    }

    function openModal() {
      if (!modal) return;
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('no-scroll');
      var closeBtn = q(modal, '.bundle-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.body.classList.remove('no-scroll');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (modal) {
      qa(modal, '[data-bundle-modal-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
    }

    function updateModalMedia(sel) {
      if (!modal) return;
      var wantId = sel && sel.m;
      if (modalImgs.length && wantId) {
        var match = modalImgs.filter(function (im) { return im.getAttribute('data-media-id') === String(wantId); });
        var show = match.length ? match : modalImgs;
        modalImgs.forEach(function (im) { im.hidden = show.indexOf(im) === -1; });
      } else if (modalImgs.length) {
        modalImgs.forEach(function (im) { im.hidden = false; });
      } else if (modalPlaceholder) {
        modalPlaceholder.style.setProperty('--swatch-color', hexMap[state.color] || '');
        var n = (state.bundle.match(/\d+/) || [])[0];
        var countEl = q(modalPlaceholder, '[data-placeholder-count]');
        if (countEl) countEl.textContent = n ? '\u00d7' + n : '';
      }
    }

    function render() {
      qa(root, '.pkg-card').forEach(function (card) {
        var b = card.getAttribute('data-bundle'), on = b === state.bundle;
        card.classList.toggle('active', on);
        card.setAttribute('aria-pressed', on ? 'true' : 'false');
        var v = find(b, state.color) || find(b, '');
        if (v) {
          q(card, '.price').textContent = v.pf;
          q(card, '.was').textContent = v.cf;
          var save = q(card, '.save');
          if (save) {
            var word = save.getAttribute('data-save-word') || '';
            save.textContent = v.sf ? (word ? word + ' ' : '') + v.sf : '';
          }
        }
      });
      qa(root, '.swatch').forEach(function (s) { s.classList.toggle('active', s.getAttribute('data-color') === state.color); });
      var sel = find(state.bundle, state.color);
      if (lab) lab.textContent = [state.bundle, state.color].filter(Boolean).join(' \u00b7 ');
      if (priceEl && sel) priceEl.textContent = sel.pf;
      if (btn) {
        btn.disabled = !sel || !sel.a;
        btn.textContent = sel && !sel.a ? (S.soldOut || 'Sold out') : (S.addToCart || 'Add to cart');
      }
      if (modalTitle) modalTitle.textContent = [state.bundle, state.color].filter(Boolean).join(' \u00b7 ');
      if (modalPrice && sel) modalPrice.textContent = sel.pf;
      if (modalAdd) {
        modalAdd.disabled = !sel || !sel.a;
        modalAdd.textContent = sel && !sel.a ? (S.soldOut || 'Sold out') : (S.addToCart || 'Add to cart');
      }
      updateModalMedia(sel);
    }

    function addToCart(originEl) {
      var v = find(state.bundle, state.color);
      if (!v || !v.a || !window.CinchCart) return;
      var src = originEl || btn;
      if (btn) btn.disabled = true;
      if (modalAdd) modalAdd.disabled = true;
      var fly = window.CinchCart.flyToCart ? window.CinchCart.flyToCart(src) : Promise.resolve();
      var add = window.CinchCart.add([{ id: v.id, quantity: 1 }]);
      Promise.all([fly, add])
        .then(function () { closeModal(); window.CinchCart.afterAdd(); })
        .catch(function (err) { window.CinchCart.toast((err && err.message) || S.error); })
        .then(render);
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('.pkg-card,.swatch,[data-add],[data-modal-add]') : null;
      if (!t || !root.contains(t)) return;
      if (t.classList.contains('pkg-card')) { state.bundle = t.getAttribute('data-bundle'); render(); openModal(); }
      else if (t.classList.contains('swatch')) { state.color = t.getAttribute('data-color'); render(); }
      else if (t.hasAttribute('data-add')) { addToCart(btn); }
      else if (t.hasAttribute('data-modal-add')) { addToCart(modalAdd); }
    });

    render();
  }

  /* ---------- offer countdown (only shown for a real end date) ---------- */
  function initCountdown(bar) {
    if (bar.getAttribute('data-ready')) return;
    bar.setAttribute('data-ready', '1');
    var end = new Date(bar.getAttribute('data-offer-end')).getTime();
    var cd = q(bar, '.cd');
    if (isNaN(end) || end <= Date.now() || !cd) return;
    bar.hidden = false;
    (function tick() {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
      cd.textContent = (d ? d + 'd ' : '') + z(h) + ':' + z(m) + ':' + z(s % 60);
      if (s > 0) setTimeout(tick, 1000); else bar.hidden = true;
    })();
  }

  /* ---------- animations: still frame for reduced motion, pause when off screen ---------- */
  function initAnimations() {
    var smil = qa(document, '#heroAnim,#cinchAnim,#closeAnim,#outfitAnim');
    if (reduce) {
      var frames = { heroAnim: 5.2, cinchAnim: 4.2, closeAnim: 4.6, outfitAnim: 4.6 };
      smil.forEach(function (s) {
        try { s.pauseAnimations(); s.setCurrentTime(frames[s.id] || 4.6); } catch (e) {}
      });
      return;
    }
    if (!('IntersectionObserver' in window)) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var t = en.target;
          if (t.classList.contains('w')) t.classList.toggle('off', !en.isIntersecting);
          else { try { en.isIntersecting ? t.unpauseAnimations() : t.pauseAnimations(); } catch (err) {} }
        });
      }, { rootMargin: '160px' });
    }
    qa(document, '.w').concat(smil).forEach(function (t) {
      if (t.getAttribute('data-observed')) return;
      t.setAttribute('data-observed', '1');
      io.observe(t);
    });
  }

  /* ---------- sticky purchase bar: tuck away when the footer appears ---------- */
  var footerObserver = null;
  function initSticky() {
    var bars = qa(document, '[data-sticky]');
    document.body.classList.toggle('has-sticky', bars.length > 0);
    var footer = document.querySelector('[data-site-footer]');
    if (!bars.length || !footer || !('IntersectionObserver' in window)) return;
    if (footerObserver) footerObserver.disconnect();
    footerObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        qa(document, '[data-sticky]').forEach(function (b) { b.classList.toggle('hide', en.isIntersecting); });
      });
    });
    footerObserver.observe(footer);
  }

  function initAll() {
    qa(document, '[data-cinch-bundles]').forEach(initBundles);
    qa(document, '[data-offer-end]').forEach(initCountdown);
    initAnimations();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
